//UI reducer

export const SET_THEME = "SET_THEME";
export const ON_ERROR = "ON_ERROR";

export const SET_COMMENT = "SET_COMMENT";
export const SET_AUTH = "SET_AUTH";
